import type { SVGProps } from 'react';

const RejectPtoIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <rect
          width="14"
          height="14"
          rx="7"
          fill="#F79009"
        />
        <path
          d="M11.0835 4.66927L8.75016 7.0026H10.5002C10.5002 8.93344 8.931 10.5026 7.00016 10.5026C6.411 10.5026 5.851 10.3568 5.36683 10.0943L4.51516 10.9459C5.23266 11.4009 6.08433 11.6693 7.00016 11.6693C9.5785 11.6693 11.6668 9.58094 11.6668 7.0026H13.4168L11.0835 4.66927ZM3.50016 7.0026C3.50016 5.07177 5.06933 3.5026 7.00016 3.5026C7.58933 3.5026 8.14933 3.64844 8.6335 3.91094L9.48516 3.05927C8.76766 2.60427 7.916 2.33594 7.00016 2.33594C4.42183 2.33594 2.3335 4.42427 2.3335 7.0026H0.583496L2.91683 9.33594L5.25016 7.0026H3.50016Z"
          fill="white"
        />
      </svg>
    );
  };

  export default RejectPtoIcon;
  